import { Link } from "react-router-dom";
import { Leaf, Mail, MapPin, Phone } from "lucide-react";
import logoImage from '../assets/logo.png';

const Footer = () => (
  <footer className="border-t border-border bg-primary text-white">
    <div className="container-wide grid gap-10 py-14 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-md bg-accent/20 text-accent">
            <img src={logoImage} alt="CREDO Logo" className="h-10 w-12" />
          </span>
          <span className="font-serif text-lg font-bold tracking-tight text-foreground">
            Climate Resilient and Development Organization (CRDO)
          </span>
        </div>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground">
          Advancing climate resilience, child protection, and inclusive development across the Horn of Africa.
        </p>
      </div>


      <div>
        <h4 className="font-serif text-sm font-bold uppercase tracking-wider text-foreground">Explore</h4>
        <ul className="mt-4 space-y-2 text-sm text-foreground">
          <li><Link to="/about" className="hover:text-accent">About us</Link></li>
          <li><Link to="/programs" className="hover:text-accent">Programs</Link></li>
          <li><Link to="/impact" className="hover:text-accent">Our impact</Link></li>
          <li><Link to="/where-we-work" className="hover:text-accent">Where we work</Link></li> 
          <li><Link to="/partners" className="hover:text-accent">Partners</Link></li> 
          <li><Link to="/contact" className="hover:text-accent">Contact</Link></li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <h4 className="font-serif text-sm font-bold uppercase tracking-wider text-foreground">Reach us</h4>
        <div className="mt-4 grid gap-4 sm:grid-cols-3">
          <div>
            <p className="font-medium text-foreground">Ethiopia</p>
            <ul className="mt-2 space-y-2 text-sm text-foreground">
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-accent flex-shrink-0" /> Moyale, Ethiopia</li>
              <li className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4 text-accent flex-shrink-0" /> +251990415466</li>
            </ul>
          </div>
          <div>
            <p className="font-medium text-foreground">Kenya</p>
            <ul className="mt-2 space-y-2 text-sm text-foreground">
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-accent flex-shrink-0" /> Nairobi, Kenya</li>
              <li className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4 text-accent flex-shrink-0" /> +254 721338450</li>
            </ul>
          </div>
          <div>
            <p className="font-medium text-foreground">Somalia</p>
            <ul className="mt-2 space-y-2 text-sm text-foreground">
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-accent flex-shrink-0" /> Mogadishu, Somalia</li>
              <li className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4 text-accent flex-shrink-0" /> +252619514315</li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <h4 className="font-serif text-sm font-bold uppercase tracking-wider text-foreground">Contact</h4>
        <ul className="mt-4 space-y-3 text-sm text-foreground">
          <li className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4 text-accent" /> info@credohorn.org</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-wide flex flex-col items-start justify-between gap-2 py-5 text-xs text-white/60 md:flex-row md:items-center">
        <p>© {new Date().getFullYear()} www.credohorn.org. All rights reserved.</p>
        <p>Registered NGO · Federal Republic of Ethiopia</p>
      </div>
    </div>
  </footer>
);

export default Footer;
